import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icons/check-success.svg'
import _imports_1 from '@/assets/img/icons/add-user-black.svg'


const _hoisted_1 = { class: "px-5 py-3 flex flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-4" }, " Berhasil ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-40 h-40 mb-4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6 text-center" }, " Proyek Berhasil disimpan, anda bisa memulai untuk menambahkan peserta proyek ", -1)
const _hoisted_5 = { class: "w-full flex flex-col mt-3 gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: $setup.isShown,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShown) = $event)),
    "hide-footer": "",
    "hide-header": "",
    "no-close-on-backdrop": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toParticipantPage && $setup.toParticipantPage(...args))),
            class: "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center justify-center gap-3"
          }, [
            _hoisted_6,
            _createTextVNode(" Tambah Peserta ")
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
            class: "w-full px-4 py-2 bg-transparent border-1 border-gray-200 rounded text-blue-900 text-sm leading-6 font-semibold"
          }, " Tutup ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}